/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var icons   = require('magcore-theme/icons'),

    STYLED_TEXT = ' theme-styled-text',

    tools   = require('../modules/tools');

module.exports = function ( $item, data ) {
    var $left,
        $leftWrap,
        $right,
        $logoWrapper,
        $iconWrapper;

    if ( !$item.ready ) {
        if ($item.lastChild ) {
            $item.removeChild($item.lastChild);
        }

        $leftWrap = document.createElement('div');
        $leftWrap.className = 'left-column-wrapper';

        $left = document.createElement('div');
        $left.className = 'left-column theme-styled-background theme-styled-text';

        $right = document.createElement('div');
        $right.className = 'right-column';

        $item.$number = document.createElement('div');
        $item.$number.className = 'number classic-tv-special-bg theme-styled-text';
        $left.appendChild($item.$number);

        $item.$logo = document.createElement('div');
        $logoWrapper = document.createElement('div');
        $item.$logo.className = 'logo';
        $logoWrapper.className = 'logo-wrapper';
        $logoWrapper.appendChild($item.$logo);
        $left.appendChild($logoWrapper);

        $item.$title = document.createElement('div');
        $item.$title.className = 'title';
        $left.appendChild($item.$title);


        $iconWrapper = document.createElement('div');
        $iconWrapper.className = 'icon-wrapper';


        $item.$lockIcon = document.createElement('div');
        $item.$lockIcon.className = icons.LOCK + STYLED_TEXT;
        $left.appendChild($item.$lockIcon);


        $item.$timeShiftIcon = document.createElement('div');
        $item.$timeShiftIcon.className = icons.TIMESHIFT + STYLED_TEXT;
        $left.appendChild($item.$timeShiftIcon);

        $item.$favorite = document.createElement('div');
        $item.$favorite.className = icons.FAVORITE_ACTIVE + ' active';
        $left.appendChild($item.$favorite);

        $item.$epg = document.createElement('div');
        $item.$epg.className = 'epg theme-styled-background theme-styled-text';
        $right.appendChild($item.$epg);

        // $left.appendChild($iconWrapper);

        $leftWrap.appendChild($left);
        $item.appendChild($leftWrap);
        $item.appendChild($right);


        // $item.appendChild(dom.tag('div', {className: 'list left theme-styled-background theme-styled-text'},
        //     $item.$num = dom.tag('div', {className: 'icon-box num theme-styled-text'}),
        //     $item.$icon = dom.tag('div', {className: 'icon-box channel'}),
        //     $item.$title = dom.tag('div', {className: 'text'}),
        //     dom.tag('div', {className: 'row-icon'},
        //         $item.censored = dom.tag('div', {className: 'theme-icon theme-icon-lock theme-styled-text'}),
        //         $item.$serverTimeShift = dom.tag('div', {className: 'theme-icon theme-icon-timeshift theme-styled-text'}),
        //         $item.$favorite = dom.tag('div', {className: 'theme-icon theme-icon-favorite-active active'})
        //     )
        // ));
        // $item.appendChild(dom.tag('div', {className: 'list right theme-styled-background'},
        //     $item.$epg = $item.appendChild(dom.tag('div', {className: 'text'}))
        // ));
        $item.ready = true;
    }

    $item.$number.innerText = data.number;

    $item.$title.innerText = data.name;

    if ( data.logo ) {
        $item.$logo.classList.remove('hide');
        $item.$logo.style.backgroundImage = 'url(' + core.backend.host + data.logo + ')';
    } else {
        $item.$logo.classList.add('hide');
        $item.$logo.style.backgroundImage = null;
    }

    if ( tools.isCensored(data) ) {
        $item.$lockIcon.classList.remove('hide');
    } else {
        $item.$lockIcon.classList.add('hide');
    }

    if ( data.local_timeshift || (data.archive && data.archive_range) ) {
        $item.$timeShiftIcon.classList.remove('hide');
    } else {
        $item.$timeShiftIcon.classList.add('hide');
    }

    if ( data.favorite ) {
        $item.$favorite.classList.remove('hide');
    } else {
        $item.$favorite.classList.add('hide');
    }


    if ( data.currentEpg && data.currentEpg.title && !tools.isCensored(data) ) {
        $item.$epg.innerText = data.currentEpg.title || '';
    } else {
        $item.$epg.innerText = '';
    }


};
